import { Component, Output } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { Profile, UserDto } from 'src/app/server-api/models';
import { UserControllerService } from 'src/app/server-api/services';
import { DetailComponent } from 'src/app/utils-flc/detail/detail.component';
import { IUserFormGroup } from './IUserFormGroup';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent  extends DetailComponent {
  user: UserDto;
  public showChangePassword: boolean = false;
  public originalEnabled: boolean = false;


  selectedProfiles: Profile[] = [] ;
  @Output()  preSelectedProfile: Profile[] = [];

  constructor(
    public override translate: TranslateService,
    private userService: UserControllerService,
    public override sidenavService: SideNavService,
    public override router: Router,
    private formBuilder: UntypedFormBuilder
  ) {
    super(translate, sidenavService, router);
  }

  override ngOnInit()
  {
    this.profilesAllowEdit = 'ADMIN';
    super.ngOnInit();
  }

  override initItem(): void {
    super.initItem();
    //init an empty dto and set the invisible fields
    this.user = {} as any as UserDto;

    this.initForm();
    this.columnsVisible.set('id', false);
  }

  override getItem(request) {
    super.getItem(request);

    console.log("before getitem " + request.id);

    this.userService.getUser(request).subscribe((data: UserDto) => {
      this.id = data.id;
      this.user = data;
      this.name = data.displayName;
      this.originalEnabled = this.user.enabled;
      this.selectedProfiles[0] = this.user.profile;
      this.preSelectedProfile = this.selectedProfiles;

      this.initForm();
      this.detailForm.controls['id'].disable();
    });
  }

  override setForm() {
    //set visibility fields, set FormGroup and validators
    super.setForm();

    if (this.disableByProfile)
    {
      this.columnsVisible = new Map([
        ['id', false],
        ['displayName', true],
        ['email', true],
        ['enabled', true],
        ['profile', false],
        ['profile_disabled', true]
      ]);

    }
    else
    {
      this.columnsVisible = new Map([
        ['id', false],
        ['displayName', true],
        ['email', true],
        ['enabled', true],
        ['profile', true],
        ['profile_disabled', false]
      ]);
    }

    this.detailForm = this.formBuilder.group({
      id: [''],
      displayName: [{value:'', disabled: this.disableByProfile}, Validators.required],
      email: [{value:'', disabled: this.disableByProfile}, [Validators.required, Validators.email]],
      enabled: [{value:false, disabled:  this.disableByProfile}],
      roles: [[]],
      profile_disabled: [{value: '', disabled: true}]
    }) as IUserFormGroup;

    //patch value dto to formGroup
    this.detailForm.patchValue(this.user);
  }

  override initForm() {
    super.initForm();
    this.initDialogDelete('user.dialog_title');

    //set topmenu icon actions
    this.translate.get(['icon_refresh', 'icon_menu', 'icon_next', 'icon_previous']).subscribe((translations: string) => {
      this.topMenuIcons = [
        {
          icon: 'refresh',
          title: translations['icon_refresh'],
          routerLink: null,
          clickMethod: 'refresh',
          hide: false
        },
        {
          icon: 'arrow_back',
          title: translations['icon_previous'],
          routerLink: null,
          clickMethod: 'navigatePrevious',
          hide: this.hidePrevious
        },
        {
          icon: 'arrow_forward',
          title: translations['icon_next'],
          routerLink: null,
          clickMethod: 'navigateNext',
          hide: this.hideNext
        },
        {
          icon: 'menu',
          title: translations['icon_menu'],
          routerLink: RouterLinkEnum.USERS_LIST.toString(),
          clickMethod: 'dummy',
          hide: false
        },
      ];
    });
    this.setForm();
  }

  override saveOk() {
    super.saveOk();
    this.user = this.detailForm.value;
    this.user.profile = this.selectedProfiles[0];

    var response =
      this.id !== 'new'
        ? this.userService.updateUser({
            id: this.id,
            body: this.user,
          })
        : this.userService.createUser({ body: this.user });

    response.subscribe(
      (data) => {
        this.sidenavService.setLoading(false);
        if (this.id === 'new')
        {
          this.router.navigateByUrl(RouterLinkEnum.USERS.toString() + data.id);
        }
        else
          this.refresh();
      },
      (err) => {
        this.sidenavService.setLoading(false);
        console.log('User not created/updated');
        window.alert('Create/update User not possible');
      }
    );
  }


  override delete() {
    super.delete();
    this.userService.deleteUser({ id: this.id }).subscribe(
      (data) => {
        this.sidenavService.setLoading(false);
        this.router.navigateByUrl(RouterLinkEnum.USERS_LIST.toString());
        console.log('item deleted successfully!');
      },
      (error) => {
        this.sidenavService.setLoading(false);
        console.log(error.error.message);
        window.alert('Delete User not possible');
      }
    );
  }

  setSelectedProfile(profiles: Profile[])
  {
    this.selectedProfiles = profiles;
  }

  //https://www.javachinna.com/angular-spring-boot-crud-app/
}


